/* eslint-disable tailwindcss/no-custom-classname */
/* eslint-disable jsx-a11y/interactive-supports-focus */
import React, { useContext, useEffect, useState, useRef } from 'react';
import classNames from 'classnames';
import { extend } from '@thd-nucleus/data-sources';
import proptypes from 'prop-types';
import { InfoFilled } from '@one-thd/sui-icons';
import { ExperienceContext, useStore, useConfigService } from '@thd-nucleus/experience-context';
import { CheckAvailability } from '@thd-olt-component-react/check-availability';
import { shipping } from '@thd-olt-component-react/delivery-options';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { useTheme } from '@thd-olt-component-react/theme-provider';
import { TileGroup, Typography, Link } from '@one-thd/sui-atomic-components';
import { dataModel } from '../dataModel';
import { PickupHeader } from './PickupHeader';
import { DeliveryHeader } from './DeliveryHeader';
import { PickupTile } from './PickupTile';
import { DeliveryTile } from './DeliveryTile';
import {
  useFulfillmentGetData,
  useShippingGetData,
  useApplianceGetData
} from '../../hooks/useFulfillmentTiles';
import { getFulfillmentInfoFromData } from '../../hooks/useFulfillmentGetTemplates';
import { useFulfillmentListeners } from '../../hooks/useFulfillmentListeners';
import { useHandleOnChange } from '../../hooks/useHandleOnChange';
import { FulfillmentPlaceholder } from './Placeholder/FulfillmentPlaceholder';
import {
  setDeliveryZip,
  getDeliveryZip,
  isNonMajorAppliance,
  getPickupStoreName,
  isMobile,
  sth,
  bodfs,
  isMajorApplianceProductType,
  isBackorderedSelection,
  isItemOnClearance,
  isBopisLimitedQty,
  isBopisFalse,
  IsPickupUnavailable,
  isOnlinePickupUnavailable,
  isBossDominantProduct,
  isApplianceDeliveryBackordered,
  getItemIdForCheckAvailability,
  isFulfillmentMethod,
  bopis
} from '../helper/utils';
import { isSthInStock } from '../../pod/helpers/pod-fulfillment-utils';
import './fulfillment-stencil-override.scss';
import {
  FULFILLMENT_METHODS,
  CHECK_NEARBY_STORES,
  EXPERIENCE_TAGS,
  FEATURE_SWITCHES,
  FSDBM,
  DELIVERY,
  STOREFRONT_TYPES
} from '../constants';
import { CheckNearByStore } from './partials/store/CheckNearByStore';
import { DeliveryMessageUnderTile } from './DeliveryMessageUnderTile';
import { ApplianceAlerts } from './alerts/ApplianceAlerts';
import { NonMajorApplianceAlert } from './alerts/NonMajorApplianceAlert';
import useSelectedFulfillmentHasChanged from '../../hooks/useSelectedFulfillmentHasChanged';
import { ClearancePickupMessageUnderTile } from './partials/store/ClearancePickupMessageUnderTile';
import { getEdgeCase, shouldLoadPlaceholder } from './FulfillmentTilesHelper';
import { StoreOnlyAlert } from './alerts/StoreOnlyAlert';
import { BackorderedAlert } from './alerts/BackorderedAlert';
import { DeliveryDetails } from './partials/shipping/DeliveryDetails';
import { ChristmasMessaging } from './ChristmasMessaging';

const {
  number, string, func, bool, shape, object, arrayOf
} = proptypes;

const FulfillmentTiles = (props) => {
  const {
    itemId,
    lineItemId,
    storeId: primaryStoreId,
    deliveryZip,
    quantity,
    originalConfigId,
    covidAlert,
    dualPath,
    category,
    onChange,
    onDeliveryZipCodeChange,
    thresholds,
    directData,
    applianceDirectData,
    configurableApplianceItemIds,
    isBuyBoxLite,
    isCartTiles,
    localizerStoreDetails,
    quantityExceeded,
    addOnsAssemblyAndMore,
    cartAction,
    bypassQuantitySkip = false,
    disableSTH,
    disableBODFS,
    disableBOSS,
    openApplianceCheckAvailability,
    disablePickupNearBy,
    currentSelectedFulfillment,
    leadTime,
    hasCustomATC,
    configurableProductDetails,
    hideShippingThreshold,
    showZipCodeDrawer,
    defaultFulfillmentMethod,
    isLoading
  } = props;
  const theme = useTheme(FulfillmentTiles);

  // applies to exchange and eprocurement customers
  const hideCheckNearbyStoresLink = theme?.props?.hideCheckNearbyStoresLink;
  const hideDeliveryMessageUnderTile = theme?.props?.hideDeliveryMessageUnderTile;
  const hidePickupTileHeader = theme?.props?.hidePickupTileHeader;
  const hideChristmasDeliveryMessage = theme?.props?.hideChristmasDeliveryMessage || false;

  const { channel, isConsumerApp } = useContext(ExperienceContext);
  const enableApplianceDeliveryCharge = !!useConfigService('enableApplianceDeliveryCharge');
  const enableFreeDeliveryForExchange = !!useConfigService('enableFreeDeliveryForExchange');
  const applianceDeliveryThreshold = useConfigService('applianceDeliveryThreshold');
  const isHideLimitedStockClearanceEnabled = !!useConfigService('fs:isHideLimitedStockClearanceEnabled');
  const enableCheckNearbyStoreView = useConfigService('fs:enableCheckNearbyStoreView');
  const enableAssortmentStrategyDiscontinued = !!useConfigService('enableAssortmentStrategyDiscontinued');

  let bufferDays = useConfigService('fs:christmasDeliveryMessageBuffer') || 0;
  bufferDays = bufferDays === undefined ? 0 : parseInt(bufferDays, 10);

  const isGiftCardPromoEnabled = !!useConfigService(FEATURE_SWITCHES.ENABLE_GIFT_CARD_PROMOTIONS);
  const { isExchangeCustomer, storeFrontType } = useThdCustomer() || {};
  const isEprocurementCustomer = storeFrontType === STOREFRONT_TYPES.EPROCUREMENT;
  const { storeId: secondaryStoreId, storeName: defaultStoreName = '', storeZip } = useStore();
  const storeId = primaryStoreId || secondaryStoreId;
  const storeName = getPickupStoreName(directData) || defaultStoreName;
  const [zipCode, setZipCode] = useState(deliveryZip || getDeliveryZip() || storeZip);
  const [selectedFulfillmentMethod, setSelectedFulfillmentMethod] = useState(
    currentSelectedFulfillment
  );
  const [showCheckAvailability, setShowCheckAvailability] = useState(false);
  const [ffmData, setFfmData] = useState({});
  const [secondaryFFM, setPreferSecondaryFFM] = useState({
    isServiceOptedIn: false,
    prefer: false
  });
  const [applianceDeliveryData, setApplianceDeliveryData] = useState(
    isCartTiles && applianceDirectData ? applianceDirectData : null
  );

  const [isNativeDeliveryZipEventTriggered, setIsNativeDeliveryZipEventTriggered] = useState(false);
  const currentDeliveryFfm = useRef('');
  const numberOfAddOnsAndMore = addOnsAssemblyAndMore
    ? Object.keys(addOnsAssemblyAndMore).length
    : 0;
  const updateZipCode = (newZipCode) => {
    if (newZipCode) {
      setDeliveryZip(newZipCode);
      setZipCode(newZipCode);
    }
  };
  const [updatedQuantity, setQuantityToQuery] = useState(quantity);

  const onChangeOfZipCode = (data) => {
    const shippingModel = shipping(data?.shipping);
    updateZipCode(data?.shipping?.zipCode);
    // setShippingModel(updatedModel);
    if (shippingModel) {
      if (onDeliveryZipCodeChange) {
        onDeliveryZipCodeChange(
          isCartTiles
            ? data?.shipping?.zipCode
            : { ...shippingModel, zipCode: data?.shipping?.zipCode }
        );
      }
    }
  };
  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.on('NATIVE_APP.DELIVERY_ZIP', ({ output }) => {
      if (output?.deliveryZip) {
        setZipCode(output?.deliveryZip);
      }
      setIsNativeDeliveryZipEventTriggered(true);
    });
    let deliveryZipEventTimer;
    if (isConsumerApp && !isCartTiles) {
      deliveryZipEventTimer = setTimeout(() => {
        setIsNativeDeliveryZipEventTriggered((isTriggered) => {
          if (!isTriggered) {
            if (window?.newrelic) {
              window.newrelic.addPageAction(
                'DeliveryZip was not received by fulfillment component from native app within 7 seconds.',
                {
                  id: 'fulfillment',
                  name: '',
                  message: '',
                  stack: ''
                }
              );
            }
            return true;
          }
          return isTriggered;
        });
      }, 7000);
    }
    return () => {
      if (deliveryZipEventTimer) {
        clearTimeout(deliveryZipEventTimer);
      }
    };
  }, []);

  useEffect(() => {
    // for cart
    if (isCartTiles) {
      setZipCode(deliveryZip);
    }

    // call to set quantity with a delay
    const timer = setTimeout(() => {
      // Update the quantity after a wait so as to avoid unnecessary re-renders.
      const { fulfillment = {} } = ffmData;
      const fallbackMode = !!fulfillment?.fallbackMode;
      if (!fallbackMode && !quantityExceeded) {
        setQuantityToQuery(quantity);
      }
    }, 1000);
    return () => clearTimeout(timer);
  }, [deliveryZip, isCartTiles, quantity, ffmData.fulfillment]);

  const { data } = useFulfillmentGetData({
    itemId,
    zipCode,
    storeId,
    directData,
    // send updated Quantity set after a delay to improve performance
    quantity: updatedQuantity,
    bypassQuantitySkip
  });

  const isMajorAppliance = !!applianceDirectData
    || !!applianceDeliveryData
    || isMajorApplianceProductType(data?.product?.identifiers?.productType);

  const minimumQuantity = data?.product?.info?.minimumOrderQuantity;
  const queryQuantity = minimumQuantity && (!updatedQuantity || updatedQuantity < minimumQuantity)
    ? minimumQuantity : (updatedQuantity || 1);
  const { shippingData, shippingLoading } = useShippingGetData({
    itemId,
    storeId,
    zipCode,
    quantity: queryQuantity,
    original: data?.product?.pricing?.original,
    value: data?.product?.pricing?.value,
    isSthAvailable: sth(data?.product?.fulfillment),
    directData,
    isMajorAppliance,
    configId: originalConfigId
  });

  useApplianceGetData({
    itemId,
    itemIds: configurableApplianceItemIds,
    storeId,
    zipCode,
    isMajorAppliance,
    applianceDirectData,
    setApplianceDeliveryData
  });

  // for cart tiles, need to preserve selected ffm on initial load
  const getCurrentDeliveryFfm = () => {
    if (!currentDeliveryFfm?.current && isCartTiles) {
      return selectedFulfillmentMethod;
    }
    return currentDeliveryFfm?.current;
  };

  const conditionalPromotions = data?.product?.pricing?.conditionalPromotions || [];
  const giftCardPromotion = isGiftCardPromoEnabled
    ? conditionalPromotions?.find(
      (promotion) => promotion?.experienceTag === EXPERIENCE_TAGS.GIFTCARD
    )
    : null;

  useEffect(() => {
    if (data?.product) {
      setFfmData(
        getFulfillmentInfoFromData({
          data,
          itemId,
          covidAlert,
          quantity,
          originalConfigId,
          zipCode,
          storeId,
          storeName,
          channel,
          thresholds,
          setShowCheckAvailability,
          currentDeliveryFfm: getCurrentDeliveryFfm(),
          shippingData,
          isMajorAppliance,
          applianceDeliveryData,
          preferSecondaryFFM: secondaryFFM.prefer,
          isCartTiles,
          addOnsAssemblyAndMore,
          disableSTH,
          disableBODFS,
          disableBOSS,
          disablePickupNearBy,
          enableApplianceDeliveryCharge,
          enableFreeDeliveryForExchange,
          applianceDeliveryThreshold,
          isExchangeCustomer,
          isSpecialOrder: configurableProductDetails.isSpecialOrder,
          configuratorHideQuantity: configurableProductDetails.configuratorHideQuantity,
          isConfigurableBlinds: configurableProductDetails.isConfigurableBlinds,
          disableTimer: configurableProductDetails.disableTimer,
          hideShippingThreshold
        })
      );
    }
  }, [
    data.product,
    quantity,
    shippingData,
    applianceDeliveryData,
    secondaryFFM,
    numberOfAddOnsAndMore,
    configurableProductDetails.isSpecialOrder,
    configurableProductDetails.disableTimer,
    configurableProductDetails.configuratorHideQuantity,
    configurableProductDetails.isConfigurableBlinds
  ]);

  const {
    fulfillment = {},
    info,
    identifiers,
    original,
    value,
    pricing,
    availabilityType,
    fulfillmentModels,
    optimalFulfillmentFromAPI
  } = ffmData;

  const isBopisAvailable = !!bopis(fulfillment)?.locations[0]?.inventory?.isInStock;
  const isStoreOnlySku = isOnlinePickupUnavailable(fulfillment);
  const isClearanceItem = isItemOnClearance(fulfillment) && data?.product?.pricing?.clearance;
  const fallbackMode = !!fulfillment?.fallbackMode;
  const isBackorderedApplied = isBackorderedSelection(fulfillment?.backordered, selectedFulfillmentMethod);
  const deliveryFulfillmentOption = fulfillment?.fulfillmentOptions
    ?.find((fulfillmentOption) => fulfillmentOption.type === DELIVERY);
  const priorityDeliveryOptions = deliveryFulfillmentOption?.priorityDeliveryOptions;
  const fsdbmProgramInclusion = deliveryFulfillmentOption
    ?.programInclusions
    ?.find((inclusion) => inclusion?.description === FSDBM && Number(inclusion?.threshold));

  const getCurrentFulfillment = (selectedFulfillment, ffms) => {
    if (selectedFulfillment) {
      return ffms.find((option) => option.method === selectedFulfillment);
    }
    return fulfillmentModels.find((option) => option.method === selectedFulfillment);
  };

  const { pushNewFulfillmentMethod } = useSelectedFulfillmentHasChanged();

  const isPickupFfmMethod = (currentFulfillmentMethod = '') => {
    return !!(
      !currentFulfillmentMethod
      || [FULFILLMENT_METHODS.BOPIS, FULFILLMENT_METHODS.BOSS].includes(currentFulfillmentMethod)
    ); // on page load variable will be empty
  };

  useEffect(() => {
    if (fulfillmentModels) {
      const currentFulfillment = getCurrentFulfillment(
        selectedFulfillmentMethod,
        fulfillmentModels
      );
      const currentFulfillmentMethod = currentFulfillment?.method || selectedFulfillmentMethod;
      const [storeObj = {}, shippingObj = {}] = fulfillmentModels;
      currentDeliveryFfm.current = shippingObj?.method;

      if (
        isMajorAppliance
        && !currentFulfillmentMethod
        && defaultFulfillmentMethod
        && isFulfillmentMethod(
          defaultFulfillmentMethod
        )
      ) {
        setSelectedFulfillmentMethod(defaultFulfillmentMethod);
      } else if (!currentFulfillment?.enabled) {
        if (info?.hasSubscription && shippingObj?.enabled && isSthInStock(data?.product)) {
          setSelectedFulfillmentMethod(shippingObj.method);
        } else if (
          storeObj?.enabled
          && isPickupFfmMethod(currentFulfillmentMethod)
          && !storeObj?.isPickupNearby
        ) {
          setSelectedFulfillmentMethod(storeObj.method);
        } else if (shippingObj?.enabled) {
          setSelectedFulfillmentMethod(shippingObj.method);
        } else if (storeObj?.enabled) {
          // in case the delivery FFM (currentFFM) is not available, then default to the pickup
          setSelectedFulfillmentMethod(storeObj.method);
        }
      }
    }
  }, [fulfillmentModels, secondaryFFM]);

  useEffect(() => {
    // for open delivery zip overlay from cart
    if (window.LIFE_CYCLE_EVENT_BUS && isCartTiles) {
      window.LIFE_CYCLE_EVENT_BUS.off('cart.delivery-zip-modal');
      window.LIFE_CYCLE_EVENT_BUS.on('cart.delivery-zip-modal', () => {
        setShowCheckAvailability(true);
      });
    }
  }, [cartAction]);

  useHandleOnChange({
    onChange,
    getCurrentFulfillment,
    fulfillmentModels,
    availabilityType,
    selectedFulfillmentMethod,
    itemId,
    quantity,
    primaryStoreNum: applianceDeliveryData?.primaryStrNbr,
    isCartTiles,
    isBackorderedApplied
  });

  useFulfillmentListeners({
    fulfillmentModels,
    setSelectedFulfillmentMethod,
    setPreferSecondaryFFM,
    optimalFulfillmentFromAPI
  });

  if (
    shouldLoadPlaceholder({
      applianceDeliveryData,
      fulfillmentModels,
      isCartTiles,
      isConsumerApp,
      isMajorAppliance,
      isNativeDeliveryZipEventTriggered,
      isLoading
    })
  ) {
    return <FulfillmentPlaceholder channel={channel} />;
  }

  const [storeObj = {}, shippingObj = {}] = fulfillmentModels;
  const bundleComponents = data?.product?.fulfillment?.bundleComponents;

  const checkAvailabilityComponent = showCheckAvailability ? (
    <span data-testid="check-availability">
      <CheckAvailability
        useDrawerModal
        showCheckAvailability={showCheckAvailability}
        setShowCheckAvailability={setShowCheckAvailability}
        itemId={getItemIdForCheckAvailability(bundleComponents, itemId)}
        price={parseInt((value * quantity).toFixed(2), 10)}
        zipCode={zipCode}
        onSubmitForm={(response) => {
          if (response) {
            onChangeOfZipCode(response);
          }
          setShowCheckAvailability(false);
        }}
        quantity={quantity}
        inputHeaderTitle="Zip Code"
      />
    </span>
  ) : null;

  const edgeCase = getEdgeCase({
    addOnsAssemblyAndMore,
    applianceDeliveryData,
    availabilityType,
    category,
    checkAvailabilityComponent,
    dualPath,
    fulfillment,
    isExchangeCustomer,
    isEprocurementCustomer,
    isMajorAppliance,
    itemId,
    originalConfigId,
    product: data?.product,
    setShowCheckAvailability,
    shippingObj,
    showCheckAvailability,
    storeObj,
    storeName,
    enableAssortmentStrategyDiscontinued
  });

  if (edgeCase) {
    return edgeCase;
  }

  const getWrapperClasses = (fulfillmentModel, removeMargin = false) => {
    const { enabled, method, tooltip } = fulfillmentModel;

    let cardSelected = false;
    let cardUnselected = false;
    if (enabled) {
      if (selectedFulfillmentMethod === method) {
        cardSelected = true;
      } else {
        cardUnselected = true;
      }
    }

    return classNames({
      card: true,
      u__legal: isMobile(channel),
      'mobile--margin-right': true,
      'card-container': true,
      'u__text--primary': !enabled,
      'card-selected': cardSelected,
      'card-unselected': cardUnselected,
      'card-enabled': enabled,
      'card-unclickable': !enabled,
      'card-info': tooltip,
      'u__m-right-none': removeMargin
    });
  };

  const showAvailableText = isClearanceItem || isBopisFalse(fulfillment);

  const onFulfillmentMethodChanged = (newMethod) => {
    setSelectedFulfillmentMethod(newMethod);
    pushNewFulfillmentMethod({ selectedFulfillmentMethod: newMethod });
  };

  const hideClearanceExperienceForLQTY = (isHideLimitedStockClearanceEnabled && isClearanceItem
    && isBopisLimitedQty(fulfillment));

  const pickupUnavailable = IsPickupUnavailable(
    { fulfillment, isClearanceItem, storeObj, hideClearanceForLimitedQty: hideClearanceExperienceForLQTY });

  const isApplianceBackordered = isApplianceDeliveryBackordered(applianceDeliveryData);

  const { BOSS, STH, APPLIANCE } = FULFILLMENT_METHODS;

  const renderSubTemplate = () => {
    const currentFulfillment = getCurrentFulfillment(selectedFulfillmentMethod, fulfillmentModels);
    const shouldShowSubTemplate = !(selectedFulfillmentMethod === 'BOPIS'
      && isBossDominantProduct(fulfillment, isCartTiles))
      && currentFulfillment?.subTemplate
      && !currentFulfillment?.unavailable;

    if (!shouldShowSubTemplate) {
      return null;
    }

    return <>{currentFulfillment.subTemplate}</>;
  };

  const renderCheckNearbyStoreSection = () => {
    if (isMajorAppliance || !enableCheckNearbyStoreView || bundleComponents) {
      return null;
    }

    return (
      <>
        <div
          className={(!hideCheckNearbyStoresLink || (shippingObj.enabled && !isCartTiles)
            ? 'sui-grid sui-grid-cols-2 sui-gap-3 sui-pt-3' : '')}
        >
          {!hideCheckNearbyStoresLink && (
            <Typography variant="body-base">
              <CheckNearByStore
                itemId={itemId}
                quantity={quantity}
                originalConfigId={originalConfigId}
                lineItemId={lineItemId}
                addOnsAssemblyAndMore={addOnsAssemblyAndMore}
                isCartTiles={isCartTiles}
                storeIdFromCart={storeId}
                leadTime={leadTime}
                hasCustomATC={hasCustomATC}
                storeNameLink
                isBopisAvailable={isBopisAvailable}
                enableCheckNearbyStoreView={enableCheckNearbyStoreView}
                giftCardPromotion={giftCardPromotion}
              >
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <Link data-testid="check-nearby-stores">
                  {CHECK_NEARBY_STORES}
                </Link>
              </CheckNearByStore>
            </Typography>
          )}
          {shippingObj.enabled && (
            <DeliveryDetails
              itemId={itemId}
              storeId={storeId}
              zipCode={zipCode}
              quantity={queryQuantity}
              shippingData={shippingData}
              isCartTiles={isCartTiles}
              fallbackMode={fallbackMode}
              originalConfigId={originalConfigId}
              enableCheckNearbyStoreView={enableCheckNearbyStoreView}
            />
          )}
        </div>
        {renderSubTemplate()}
      </>
    );
  };

  const renderAlerts = () => {
    return (
      <div className="fulfillment__fullcontent-alerts-alerts">
        {!hideClearanceExperienceForLQTY && isClearanceItem && (
          <ClearancePickupMessageUnderTile
            isClearanceItem={isClearanceItem}
            localstore={storeName}
            pricing={data?.product?.pricing}
            isCartTiles={isCartTiles}
            itemId={itemId}
          />
        )}
        <ApplianceAlerts applianceDeliveryData={applianceDeliveryData} storeObj={storeObj} />

        {((fulfillment?.backordered || isApplianceBackordered)
          && [BOSS, STH, APPLIANCE].includes(selectedFulfillmentMethod)) && (
          <BackorderedAlert isMajorAppliance={isMajorAppliance} />
        )}
      </div>
    );
  };

  const renderAdditionalAlerts = () => {
    const currentFulfillment = getCurrentFulfillment(selectedFulfillmentMethod, fulfillmentModels);

    return (
      <>
        {shippingObj?.enabled && (
          <>
            {isNonMajorAppliance(identifiers?.productType, info) && <NonMajorApplianceAlert />}
          </>
        )}
        {isStoreOnlySku && (!isBopisLimitedQty(fulfillment) && !isItemOnClearance(fulfillment)) && <StoreOnlyAlert />}
      </>
    );
  };

  const renderBossDominantSubTemplate = () => {
    const currentFulfillment = getCurrentFulfillment(selectedFulfillmentMethod, fulfillmentModels);
    const shouldShowBossSubTemplate = (selectedFulfillmentMethod === 'BOPIS'
      && isBossDominantProduct(fulfillment, isCartTiles))
      && currentFulfillment?.subTemplate
      && !currentFulfillment?.unavailable;

    if (!shouldShowBossSubTemplate) {
      return null;
    }

    return <>{currentFulfillment.subTemplate}</>;
  };

  const renderChristmasMessaging = () => (
    <ChristmasMessaging
      applianceDeliveryData={applianceDeliveryData}
      fulfillment={fulfillment}
      bufferDays={bufferDays}
      checkArrivesAfter
      channel={channel}
    />
  );

  const renderDeliveryMessageUnderTile = () => {
    const shouldShowDeliveryMessage = (!fallbackMode || isMajorAppliance)
      && !hideDeliveryMessageUnderTile
      && !bundleComponents
      && !(isMajorAppliance && (isCartTiles || selectedFulfillmentMethod === 'BOPIS'));

    if (!shouldShowDeliveryMessage) {
      return null;
    }

    return (
      <DeliveryMessageUnderTile
        shippingData={shippingData}
        bodfsFulfillment={bodfs(fulfillment)}
        currDeliveryTileFfm={shippingObj?.method}
        isShippingLoading={shippingLoading}
        isMajorAppliance={isMajorAppliance}
        applianceDeliveryData={applianceDeliveryData}
        original={original}
        value={value}
        pricing={pricing}
        enableApplianceDeliveryCharge={enableApplianceDeliveryCharge}
        enableFreeDeliveryForExchange={enableFreeDeliveryForExchange}
        applianceDeliveryThreshold={applianceDeliveryThreshold}
        isExchangeCustomer={isExchangeCustomer}
        isBuyBoxLite={isBuyBoxLite}
        isCartTiles={isCartTiles}
        priorityDeliveryOptions={priorityDeliveryOptions}
        fsdbmProgramInclusion={fsdbmProgramInclusion}
      />
    );
  };

  const renderFinalSubTemplate = () => {
    const currentFulfillment = getCurrentFulfillment(selectedFulfillmentMethod, fulfillmentModels);
    const shouldShowFinalSubTemplate = !enableCheckNearbyStoreView
      && !(selectedFulfillmentMethod === 'BOPIS' && isBossDominantProduct(fulfillment, isCartTiles))
      && currentFulfillment?.subTemplate
      && !currentFulfillment?.unavailable;

    if (!shouldShowFinalSubTemplate) {
      return null;
    }

    return <>{currentFulfillment.subTemplate}</>;
  };

  const renderAPOFPOMessaging = () => {
    const isApoFpoEligible = data?.product?.fulfillment?.apoFpoEligible;

    if (!isApoFpoEligible || !isExchangeCustomer) {
      return null;
    }

    return (
      <div
        className="sui-mt-3 sui-mb-3 sui-flex sui-items-center sui-gap-2"
      >
        <InfoFilled
          size="small"
          style={{ color: '#499992' }}
        />
        <Typography
          variant="body-base"
          height="normal"
        >Delivers to APO/FPO/DPO
        </Typography>
      </div>
    );
  };

  return (
    <div
      // eslint-disable-next-line tailwindcss/no-arbitrary-value
      className="sui-max-w-[365px] sui-grid-cols-12"
      data-component="FulfillmentTiles"
      data-testid="fulfillment-tiles-has-rendered"
    >
      <div className="sui-flex sui-flex-wrap sui-mb-2 sui-w-full sui-justify-between">
        {/* TODO: Determine best way to show either store from zipcode or nearby store */}
        <PickupHeader
          storeName={storeName}
          itemId={itemId}
          originalConfigId={originalConfigId}
          quantity={quantity}
          lineItemId={lineItemId}
          pickupUnavailable={pickupUnavailable}
          isMajorAppliance={isMajorAppliance}
          isCartTiles={isCartTiles}
          localizerStoreName={localizerStoreDetails?.name}
          addOnsAssemblyAndMore={addOnsAssemblyAndMore}
          isExchangeCustomer={isExchangeCustomer}
          storeId={storeId}
          leadTime={leadTime}
          hasCustomATC={hasCustomATC}
          disablePickupNearBy={disablePickupNearBy}
          showAvailableText={showAvailableText}
          isConfigurator={configurableProductDetails?.isConfigurableBlinds}
          hideHeader={hidePickupTileHeader && pickupUnavailable}
          enableCheckNearbyStoreView={enableCheckNearbyStoreView}
          isBIP={!!bundleComponents}
        />
        <DeliveryHeader
          itemId={itemId}
          quantity={quantity}
          zipCode={zipCode}
          showCheckAvailability={showCheckAvailability}
          setShowCheckAvailability={setShowCheckAvailability}
          isCartTiles={isCartTiles}
          lineItemId={lineItemId}
          fulfillmentMethod={selectedFulfillmentMethod}
          applianceCountInCart={
            applianceDirectData?.DeliveryAvailabilityResponse?.deliveryAvailability
              ?.applianceCountInCart
          }
          channel={channel}
          isMajorAppliance={isMajorAppliance}
          openApplianceCheckAvailability={openApplianceCheckAvailability}
          showZipCodeDrawer={showZipCodeDrawer}
        />
      </div>
      <div className="sui-w-full" />
      {checkAvailabilityComponent}
      <TileGroup
        value={selectedFulfillmentMethod}
        onChange={setSelectedFulfillmentMethod}
        aria-label="FulfillmentTiles"
        disableExclusive
        // eslint-disable-next-line tailwindcss/no-arbitrary-value
        className="sui-flex sui-gap-3 sui-w-fit sui-w-full sui-min-h-[148px] fulfillment-tiles-group"
      >
        <>
          {storeObj.isPickupNearby ? (
            <CheckNearByStore
              itemId={itemId}
              quantity={quantity}
              originalConfigId={originalConfigId}
              lineItemId={lineItemId}
              addOnsAssemblyAndMore={addOnsAssemblyAndMore}
              isCartTiles={isCartTiles}
              storeIdFromCart={storeId}
              leadTime={leadTime}
              hasCustomATC={hasCustomATC}
            >
              <PickupTile
                getWrapperClasses={getWrapperClasses}
                fulfillmentObj={storeObj}
                originalConfigId={originalConfigId}
                lineItemId={lineItemId}
                currentFulfillmentMethod={selectedFulfillmentMethod}
                setSelectedFulfillmentMethod={onFulfillmentMethodChanged}
                isCartTiles={isCartTiles}
                isCheckNearByStore
                giftCardPromotion={giftCardPromotion}
              />
            </CheckNearByStore>
          ) : (
            <PickupTile
              getWrapperClasses={getWrapperClasses}
              fulfillmentObj={storeObj}
              originalConfigId={originalConfigId}
              lineItemId={lineItemId}
              currentFulfillmentMethod={selectedFulfillmentMethod}
              setSelectedFulfillmentMethod={onFulfillmentMethodChanged}
              isCartTiles={isCartTiles}
              storeIdFromCart={storeId}
            />
          )}
          <DeliveryTile
            getWrapperClasses={getWrapperClasses}
            fulfillmentObj={shippingObj}
            currentFulfillmentMethod={selectedFulfillmentMethod}
            setSelectedFulfillmentMethod={onFulfillmentMethodChanged}
            lineItemId={directData?.lineItemId}
          />
        </>
      </TileGroup>

      {renderCheckNearbyStoreSection()}

      {renderAPOFPOMessaging()}

      {renderAlerts()}
      {renderAdditionalAlerts()}
      {renderBossDominantSubTemplate()}
      {(!isCartTiles && !hideChristmasDeliveryMessage) && renderChristmasMessaging()}
      {renderDeliveryMessageUnderTile()}
      {renderFinalSubTemplate()}
    </div>
  );
};

FulfillmentTiles.displayName = 'FulfillmentTiles';

FulfillmentTiles.themeProps = {
  hideDeliveryMessageUnderTile: bool,
  hidePickupTileHeader: bool,
  hideCheckNearbyStoresLink: bool
};

FulfillmentTiles.defaultThemeProps = {
  hideDeliveryMessageUnderTile: false,
  hidePickupTileHeader: false,
  hideCheckNearbyStoresLink: false
};

FulfillmentTiles.propTypes = {
  /** An Item that has product highlights */
  itemId: string.isRequired,
  storeId: string,
  deliveryZip: string,
  covidAlert: bool,
  quantity: number,
  originalConfigId: string,
  onChange: func,
  dualPath: bool,
  onDeliveryZipCodeChange: func,
  thresholds: shape({
    bodfsMinimumThreshold: number,
    bopisMinimumThreshold: number,
    bopisMinimumThresholdStores: string,
    bopisHolidayTiming: number
  }),
  // eslint-disable-next-line react/forbid-prop-types
  directData: object,
  // eslint-disable-next-line react/forbid-prop-types
  applianceDirectData: object,
  configurableApplianceItemIds: arrayOf(string),
  isBuyBoxLite: bool,
  isCartTiles: bool,
  // eslint-disable-next-line react/forbid-prop-types
  localizerStoreDetails: object,
  quantityExceeded: bool,
  // eslint-disable-next-line react/forbid-prop-types
  addOnsAssemblyAndMore: object,
  cartAction: string,
  bypassQuantitySkip: bool,
  category: string,
  lineItemId: string,
  disableSTH: bool,
  disableBODFS: bool,
  disableBOSS: bool,
  openApplianceCheckAvailability: func,
  disablePickupNearBy: bool,
  currentSelectedFulfillment: string,
  defaultFulfillmentMethod: string,
  leadTime: number,
  hasCustomATC: bool,
  configurableProductDetails: shape({
    isSpecialOrder: bool,
    configuratorHideQuantity: bool,
    isConfigurableBlinds: bool,
    disableTimer: bool
  }),
  hideShippingThreshold: bool,
  showZipCodeDrawer: bool,
  /** When true, displays a loading placeholder regardless of other conditions */
  isLoading: bool
};

FulfillmentTiles.defaultProps = {
  quantity: 1,
  originalConfigId: null,
  storeId: null,
  deliveryZip: '',
  covidAlert: false,
  onChange: () => { },
  onDeliveryZipCodeChange: () => { },
  dualPath: false,
  thresholds: {},
  directData: null,
  applianceDirectData: null,
  configurableApplianceItemIds: null,
  isBuyBoxLite: false,
  isCartTiles: false,
  localizerStoreDetails: {},
  quantityExceeded: false,
  addOnsAssemblyAndMore: null,
  cartAction: '',
  bypassQuantitySkip: false,
  category: '',
  lineItemId: '',
  disableSTH: false,
  disableBODFS: false,
  disableBOSS: false,
  openApplianceCheckAvailability: () => { },
  disablePickupNearBy: false,
  currentSelectedFulfillment: '',
  defaultFulfillmentMethod: '',
  leadTime: 0,
  hasCustomATC: null,
  configurableProductDetails: {
    isSpecialOrder: false,
    configuratorHideQuantity: false,
    isConfigurableBlinds: false,
    disableTimer: false
  },
  hideShippingThreshold: false,
  showZipCodeDrawer: false,
  isLoading: false
};

FulfillmentTiles.dataModel = extend(CheckAvailability, dataModel, {
  bundleComponents: arrayOf(shape({
    itemId: string,
    quantity: number,
    fulfillmentOptions: arrayOf(shape({
      type: string,
      availableFulfillmentTypes: arrayOf(string)
    }))
  }))
});

export { FulfillmentTiles };
